<template>
    <div>

    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: 'SSOLogin',
    methods: {
        ...mapActions(['setLoader', 'companySSOLogin', 'setNotification'])
    },
    async mounted() {
        this.setLoader(true);
        try {
            const compID = this.$route.params.compID;
            const { redirect_url } = await this.companySSOLogin(compID);
            window.location.href = redirect_url;
        }
        catch (error) {
            this.setLoader(false);
            this.setNotification({
                msg: error,
                type: "error",
                color: "red",
            });
            setTimeout(() => {
                this.$router.push('/login');
            }, 2000);
        }
    }
}
</script>